<template>
	<div>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormQuery v-if="type=='query'" align="center" :formdata="getBase" :value="formData" :labelWidth="235"></compFormQuery>
			<compFormEdit v-else ref="relation" align="center" class="margin-layout" :formdata="getBase" v-model="formData" />
		</compWrapper>
		<compWrapper :title="$t('global.log.name',{defaultValue:'操作历史'})" theme="gray" v-if="query">
			<compLog class="margin-15" :data="opLogList" :columns="getLogcolumns"></compLog>
		</compWrapper>
		<div class="text-right">
			<vButton v-if="!query" theme="primary" class="width-15per" @click="submit">{{$t('global.common.update_submit',{defaultValue:'提交'})}}</vButton>
            <vButton class="width-15per margin-left-10" @click="cancel">{{$t('global.common.return',{defaultValue:'返回'})}}</vButton>
		</div>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>
<script>

import { HttpGetAdditionalRulesOne, HttpSaveAdditionalRulesOne, HttpGetLog } from "@/service/fedex";
import { mapState, mapGetters } from "vuex";
import mixin from '../mixin';

export default {
	mixins:[mixin],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading:false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			query: false,
			opLogList: [],
			formData: {
				// remark:'',
			}
		}
	},
	created() {
		// console.log(this.$route.params.type)
		this.query = this.type === "query";
		this.getDetail()
	},
	computed: {
		...mapGetters('dictionary', ['getCarrierServiceAllList']),
		getBase() {
			let showquery = this.type == 'edit' || this.type == 'query'
			return [
				{
                    label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
					key: "account",
					query:showquery,
				},
				{
					// label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    label: "承运商服务",
                    key: "carrierServiceCode",
                    tag:'vSelect',
                    options: this.getCarrierServiceAllList.map(item=>{
						return {
							value:item.attach.carrierServiceCode,
							label:item.attach.carrierServiceCode
						}
					}),
					show:this.type=='add',
					props: {
						filterable: true,
					}
					//
				},
				{
					// label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    label: "承运商服务",
					valueText:`${this.formData.carrierCode} (${this.formData.carrierServiceCode})`,
					show:showquery,
					query:showquery,
				},
                {
					label: this.$t('fbb.carrier.extra_rule_group',{defaultValue:'规则分组'}),
                    key: "ruleGroup",
                    tag:'vSelect',
                    options: [
						{value:1,label:this.$t('fbb.carrier.extra_group',{defaultValue:'分组'})+'1'},
						{value:2,label:this.$t('fbb.carrier.extra_group',{defaultValue:'分组'})+'2'},
						{value:3,label:this.$t('fbb.carrier.extra_group',{defaultValue:'分组'})+'3'},
						{value:4,label:this.$t('fbb.carrier.extra_group',{defaultValue:'分组'})+'4'},
						{value:5,label:this.$t('fbb.carrier.extra_group',{defaultValue:'分组'})+'5'},
						{value:6,label:this.$t('fbb.carrier.extra_group',{defaultValue:'分组'})+'6'},
					],
					props: {
						filterable: true,
					}
				},
				{
                    label: this.$t('fbb.carrier.extra_rule_name',{defaultValue:'规则名称'}),
					key: "ruleName",
				},
				{
					label: this.$t('fbb.fedexcost.rulerange',{defaultValue:'匹配公式'}),
					tag:'vInput',
					key: "ruleRangeFormula",
                },
                {
					label: this.$t('fbb.carrier.extra_cost',{defaultValue:'计费值'}),
					tag:'vInput',
					key: "ruleCostFormula",
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">USD</span>
					},
					show:this.type!='query'
				},
				{
					label: this.$t('fbb.carrier.extra_cost',{defaultValue:'计费值'}),
					valueText:`${this.formData.ruleCostFormula} USD`,
					show:this.type=='query'
				},
				{
					label: this.$t('fbb.carrier.extra_rule_remark',{defaultValue:'规则描述'}),
					tag:'vTextarea',
					key: "remark",
				},
			];
		},
	},
	methods: {
		async getDetail() {
            if (this.type === 'add') return;
            this.loading = true;
            HttpGetAdditionalRulesOne({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
			});

			if(this.query){
				// 请求日志的接口
				HttpGetLog({
					id:this.id,
					module:24,
				}).then(res=>{
					this.opLogList = res.data
				},err=>{

				})
			}
		},
		handleResponse(data={}){
			this.formData = data
		},
		async submit(){
			const valid = await this.$refs['relation'].validate();
			if (!valid) return;

			let oneitem;
			this.getCarrierServiceList.forEach(item => {
				if(this.formData.carrierServiceCode == item.attach.carrierServiceCode){
					oneitem = item
				}
			});
			this.formData.carrierCode = oneitem.attach.carrierCode

			this.loading = true
			HttpSaveAdditionalRulesOne({
				id:this.id,
				...this.formData,
				contextId:global.SYSID
			}).then(res=>{
				this.$VMessage.success(res.message);
				this.cancel()
			},err=>{
				this.$VMessage.error(err.message);
			}).finally(res=>{
				this.loading = false
			})
		},
		cancel(){
			this.$router.push({ name: "fedexAdditionalrules" })
		}
	},
}
</script>
